// extracted by mini-css-extract-plugin
export default {"label":"Label_label__Zz0X1","label__required":"Label_label__required__DIXOY"};